import axios from "axios";
import {TokenService} from "./tokenService";
import errorMessage from "../const/Tost";

// export const API_URL = 'http://localhost:3001/api';
export const API_URL = 'https://dobra-diagnostyka.com.ua/api';

const $api = axios.create({
    withCredentials: true,
    baseURL: API_URL
})

$api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    return config;
})

$api.interceptors.response.use(
    (response) => {
        return response; // Return the response if it's successful
    },
    async(error) => {
        const originalRequest = error.config;

        // Avoid retrying the token refresh request itself
        if (error.response.status === 401 && originalRequest && !originalRequest._isRetry && originalRequest.url !== `${API_URL}/refresh`){
            originalRequest._isRetry = true; // Mark the request as retried to avoid looping

            try{
                // Send a request to refresh the access token
                const response = await $api.get(`${API_URL}/refresh`, {withCredentials: true});

                // If we receive a new access token, save it and retry the original request
                if (response?.data?.accessToken){
                    TokenService.saveToken(response.data.accessToken);

                    // Add the new token to the original request's headers
                    originalRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;

                    // Retry the original request with the updated token
                    return $api.request(originalRequest);
                } else {
                    // If there's no access token in the response, handle it as a failed refresh
                    throw new Error('Failed to refresh token');
                }
            } catch(refreshError){
                // Handle errors during the token refresh
                errorMessage(refreshError, refreshError?.response?.data?.message);

                // Optionally log out the user or redirect to login if the refresh fails
            }
        }

        // If it's a different error or the refresh failed, rethrow the error
        throw error;
    }
);

export default $api;
